<div class="container">

  <app-header-dialog [iconName]="'mobile_friendly'">
    {{data.name}}
  </app-header-dialog>

  <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

    <div class='tab-content'>

      <div class='content-left'>

        <mat-form-field class="date-width" appearance="outline">
          <mat-label>Data</mat-label>
          <input matInput [matDatepicker]="picker" [errorStateMatcher]="matcher"
            [formControl]="entityForm.controls.date">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error *ngIf="entityForm.controls.date.hasError('required')">
            A data é obrigatoria
          </mat-error>
        </mat-form-field>

      </div>

      <div class='content-right'>

        <mat-form-field class="origen-width" appearance="outline">
          <mat-label>Origem</mat-label>
          <mat-select (ngModelChange)='selectOrigin($event)' [errorStateMatcher]="matcher"
            [formControl]="entityForm.controls.origin">
            <mat-option *ngFor="let origin of origins" [value]="origin.value">
              {{ origin.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="entityForm.controls.origin.hasError('required')">
            A Origen é obrigatória
          </mat-error>
        </mat-form-field>

        <mat-form-field class="origen-width" appearance="outline">
          <mat-label>Tipo</mat-label>
          <mat-select (ngModelChange)='selectType($event)' [errorStateMatcher]="matcher"
            [formControl]="entityForm.controls.payment_type">
            <mat-option *ngFor="let type of paymentTypes" [value]="type.value">
              {{ type.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="entityForm.controls.payment_type.hasError('required')">
            A Tipo é obrigatório
          </mat-error>
        </mat-form-field>


        <mat-form-field class="origen-width" *ngIf='tax_visible' appearance="outline">
          <mat-label>Taxa</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.tax"
            autocomplete="off">
          <mat-error *ngIf="entityForm.controls.tax.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>


        <mat-form-field class="origen-width" *ngIf='value_visible' appearance="outline">
          <mat-label>Valor da Anuidade</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.value"
            (blur)="value_blur()" autocomplete="off">
          <mat-error *ngIf="entityForm.controls.value.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>


        <mat-form-field class="origen-width" *ngIf='discount_visible' appearance="outline">
          <mat-label>Desconto</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" (blur)="value_blur()"
            [formControl]="entityForm.controls.discount" autocomplete="off">
          <mat-error *ngIf="entityForm.controls.discount.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="origen-width" *ngIf='total_visible' appearance="outline">
          <mat-label>Total Bruto</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.total"
            (blur)="value_blur()" autocomplete="off">
          <mat-error *ngIf="entityForm.controls.total.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>


        <mat-form-field class="origen-width" *ngIf='total_mt_visible' appearance="outline">
          <mat-label>Total Líquido</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.total_minus_tax"
            autocomplete="off">
          <mat-error *ngIf="entityForm.controls.total_minus_tax.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>


        <mat-form-field class="full-width" *ngIf='tid_visible' appearance="outline">
          <mat-label>Código da Transação</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.Tid"
            autocomplete="off">
          <mat-error *ngIf="entityForm.controls.Tid.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>


      </div>
    </div>

  </form>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

    <button [disabled]="entityForm.invalid" mat-raised-button (click)="matDialogRef.close([ entityForm ])">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>

</div>